const configs = {
  BASE_URL: "https://backend.annotic.in",
  BASE_URL_AUTO: process.env.REACT_APP_APIGW_BASE_URL
    ? process.env.REACT_APP_APIGW_BASE_URL
        :"https://backend.annotic.in"
};

export default configs;
